import 'core-js/stable';
import 'regenerator-runtime/runtime';

document.addEventListener('DOMContentLoaded', () =>
  require('./app/bootstraper.js')(),
);
document.addEventListener('DOMContentLoaded', () => require('./less.js'));
